'use client';

import { RowCardLite } from '@/components/ui/data-display/cards/RowCardLite';
import { GridCol } from '@/components/ui/layouts/grids/GridCol';

import { gridCol } from '@mage-ui/styled-system/recipes';

export const LeftyCardItem = ({ data }) => {
  return (
    <GridCol className={gridCol({ colSpanM: '6', colSpanL: '3' })}>
      <RowCardLite
        data={{
          title: data?.fields?.title,
          alt_img: data?.fields?.alt_img,
          cta_text: data?.fields?.cta_text,
          cta_slug: data?.fields?.cta_slug,
          description: data?.fields?.description || data?.fields?.text || null,
        }}
      />
    </GridCol>
  );
};
